import { CollectionServiceInterface } from '../../domain/services/collection.service.interface';
import { CollectionBffService } from './bff/collection.bff-service';

let collectionServiceInstance: CollectionServiceInterface | null = null;

export function getCollectionService(): CollectionServiceInterface {
  if (!collectionServiceInstance) {
    collectionServiceInstance = new CollectionBffService();
  }
  return collectionServiceInstance;
}
